export default () => ({
  statusAgenda: null,
  show: false,
  beenUpdated: false,
  wasRaised: false,
  nextStepButtonsAgenda: [
    {
      icon: '',
      text: 'Cadastrar Agenda',
      name: 'professional.agenda.agendas.index',
      action: null
    }
  ],
  includes: ['agenda.professional.company']
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/index/resources/data.js